import {GvfService} from "../../../gvf/js/gvf-service";
import {FormField} from "../form-field/form-field";

export class FormFieldTextarea extends FormField{
    constructor(scope,$root){
        super(scope,$root);
    }

    getVal(){
        return this.$textarea.val();
    }

    setVal(val,noEvent){
        this.$textarea.val(val);
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    ready(){
        super.ready();
        this.$textarea = this.$root.find("textarea");
        this.$textarea.keyup(
            (ev) => {
                this.tt = GvfService.delay(500,"fieldtextareakey").then(
                    () => {
                        this.$root.trigger("formField:changeVal");
                    }
                );
            }
        ).blur(
            () => {
                if(this.tt){
                    clearTimeout(this.tt);
                    this.tt = null;
                }
                this.$root.trigger("formField:checkRestrictions",{"input": this.$textarea});
            }
        ).on(
            "change",
            () => {
                this.$root.trigger("formField:changeVal");
            }
        );
    }
}

